import { preserveGrowthCorrelation } from '../utils/params.js';
import { preserveConsentedGoogleAdsAttribution } from './googleAdsAttribution.js';

const ENDPOINT = 'https://europe-west2-msh-consumer.cloudfunctions.net/growthTrackCta';

export function trackGrowthCta({ touchpointKey, destinationPath } = {}) {
    if (typeof window === 'undefined' || typeof touchpointKey !== 'string' || typeof destinationPath !== 'string') return;
    const payload = JSON.stringify({ touchpointKey, destinationPath, pagePath: window.location.pathname });
    try {
        if (navigator.sendBeacon) {
            navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'text/plain;charset=UTF-8' }));
            return;
        }
        void fetch(ENDPOINT, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: payload });
    } catch { /* CTA navigation must always win over measurement. */ }
}

export function bindGrowthCtas(root = document) {
    root.querySelectorAll('[data-growth-cta]').forEach(link => {
        if (link.dataset.growthCtaBound === 'true') return;
        const touchpointKey = link.dataset.growthCta;
        const destinationPath = link.dataset.growthDestination;
        preserveCurrentAttribution(link);
        link.addEventListener('click', () => trackGrowthCta({ touchpointKey, destinationPath }));
        link.dataset.growthCtaBound = 'true';
    });
}

function preserveCurrentAttribution(link) {
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;
    try {
        const destination = new URL(href, window.location.origin);
        if (destination.origin !== window.location.origin) return;
        link.href = preserveConsentedGoogleAdsAttribution(
            preserveGrowthCorrelation(destination.toString())
        ).toString();
    } catch {
        // A malformed optional tracking URL must never change a CTA's behaviour.
    }
}
